import type { ReactNode } from 'react';
import {
  SiteAppFrame,
  SiteContainer,
  SiteFiscalMock,
  SiteFinanceiroMock,
  SiteOsListMock,
  SitePdvMock,
} from '../SiteUi';

const BLOCKS: {
  id: string;
  kicker: string;
  title: string;
  checks: string[];
  reverse?: boolean;
  frame: ReactNode;
}[] = [
  {
    id: 'os',
    kicker: 'Ordens de serviço',
    title: 'Do veículo ao fechamento da OS sem papelada espalhada.',
    checks: ['Checklist', 'Serviços e produtos', 'Aprovações', 'Histórico do veículo'],
    frame: (
      <SiteAppFrame module="Ordens de serviço">
        <SiteOsListMock />
      </SiteAppFrame>
    ),
  },
  {
    id: 'pdv',
    kicker: 'PDV + Estoque',
    title: 'Vendeu no balcão. O estoque já sabe.',
    checks: ['Baixa no ato', 'Saldo por filial', 'Ticket no caixa'],
    reverse: true,
    frame: (
      <SiteAppFrame module="PDV">
        <SitePdvMock />
      </SiteAppFrame>
    ),
  },
  {
    id: 'fiscal',
    kicker: 'Fiscal',
    title: 'Fechou a venda. A nota sai daqui.',
    checks: ['NFC-e', 'NFS-e', 'Sem software local'],
    frame: (
      <SiteAppFrame module="Fiscal">
        <SiteFiscalMock />
      </SiteAppFrame>
    ),
  },
  {
    id: 'fin',
    kicker: 'Financeiro',
    title: 'Recebeu, pagou, cobrou. Tudo na mesma operação.',
    checks: ['Caixa do dia', 'Contas a receber', 'Cobrança automática'],
    reverse: true,
    frame: (
      <SiteAppFrame module="Financeiro">
        <SiteFinanceiroMock />
      </SiteAppFrame>
    ),
  },
];

export function SiteFeatures() {
  return (
    <section id="produto" className="scroll-mt-24 border-y border-[#d9d4cc] bg-white py-20 sm:py-28">
      <SiteContainer>
        <p className="text-sm text-[#5c5852]">Por trás da automação</p>
        <h2 className="mt-3 max-w-[16ch] font-display text-[clamp(2rem,4vw,3.25rem)] font-semibold tracking-tight text-[#16181d]">
          Uma operação inteira conectada.
        </h2>
        <div className="mt-16 space-y-20">
          {BLOCKS.map((block) => (
            <article
              key={block.id}
              className={`grid items-center gap-10 lg:grid-cols-2 lg:gap-16 ${block.reverse ? 'lg:[&>div:first-child]:order-2' : ''}`}
            >
              <div>
                <p className="text-sm text-[#f5821f]">{block.kicker}</p>
                <h3 className="mt-2 max-w-[20ch] font-display text-2xl font-semibold leading-snug text-[#16181d] sm:text-3xl">
                  {block.title}
                </h3>
                <ul className="mt-6 space-y-2 text-sm text-[#5c5852]">
                  {block.checks.map((item) => (
                    <li key={item}>✓ {item}</li>
                  ))}
                </ul>
              </div>
              {block.frame}
            </article>
          ))}
        </div>
      </SiteContainer>
    </section>
  );
}
